import React from "react";
import { CRON_TYPES } from "../../config/cronTypes";

const CronSelector = ({ cronType, setCronType }) => {
  return (
    <div className="mb-4">

      <label className="block text-sm font-medium mb-1">
        Select Cron
      </label>

      <select
        value={cronType}
        onChange={(e) => setCronType(e.target.value)}
        className="border rounded-lg px-3 py-2 w-full"
      >
        {CRON_TYPES.map((cron) => (
          <option key={cron.value} value={cron.value}>
            {cron.label}
          </option>
        ))}
      </select>

    </div>
  );
};

export default CronSelector;